// AZ ADAT-HORIZONT a vezetőségnek: visszamenőleg a kalkuláció adathiány miatt NEM lehet pontos.
//
// MIÉRT KELL (user-kérés): az Atlasban nem minden adat azonos időponttól teljes — a számlák júliustól (a
// visszamenőleges generálás kezdete), a használati adatok júniustól, az eseti díjak nagyjából szeptembertől. Ami
// nincs rögzítve, azt nem lehet becsülni; enélkül a korábbi hónapok terv–tény eltérése bevétel-kiesésnek látszana.
// A dátumok a BFF-ből jönnek (`dataHorizon`, `carry-in.ts` `DATA_HORIZON`) — a felület nem tartja őket kétszer.
import { useTranslation } from 'react-i18next';

import { formatMonthLabel } from '@/lib/month';

export interface DataHorizon {
  actualsFrom: string;
  usageFrom: string;
  oneTimeFrom: string;
}

/**
 * A blokk TARTALMA (cím + bevezető + a három pont) — a lap figyelmeztető SÁVJÁBA kerül (`PageNotice`, semleges
 * tónus), a nézet-kapcsoló és a dátumválasztó FÖLÉ, ugyanoda, ahol az Összegzés többi jelzése áll (user-kérés: a
 * három al-nézeten egy helyen és egy ritmusban). Korábban a tartalom tetején, külön kártyaként állt.
 */
export function DataHorizonNotice({ horizon }: { horizon: DataHorizon }): JSX.Element {
  const { t, i18n } = useTranslation();
  const label = (month: string): string => formatMonthLabel(month, i18n.language);
  return (
    <div className="space-y-1">
      <span className="text-foreground font-medium">{t('revenueForecast.dataHorizon.title')}</span>
      <p>{t('revenueForecast.dataHorizon.intro')}</p>
      <ul className="list-disc space-y-0.5 pl-5">
        <li>{t('revenueForecast.dataHorizon.actuals', { month: label(horizon.actualsFrom) })}</li>
        <li>{t('revenueForecast.dataHorizon.usage', { month: label(horizon.usageFrom) })}</li>
        <li>{t('revenueForecast.dataHorizon.oneTime', { month: label(horizon.oneTimeFrom) })}</li>
      </ul>
    </div>
  );
}
